export const fieldTypes = {
  0: 'select',
  1: 'number',
  2: 'float',
  3: 'text',
  4: 'textarea',
  5: 'date',
  6: 'checkbox',
  7: 'multi-checkbox',
  8: 'child-select',
}

export const fieldDefaultValue = {
  0: 1,
  1: 0,
  2: 0.0,
  3: '',
  4: '',
  5: '02.01.1900',
  6: 0,
  7: '',
  8: 1,
}
